import React from 'react';
import { useIntl, type MessageDescriptor } from 'react-intl';
import clsx from 'clsx';
import type { OutreachMailboxHealth } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

const LABEL: Record<OutreachMailboxHealth, MessageDescriptor> = {
  ok: messages.statusOk,
  warming: messages.statusWarming,
  paused: messages.statusPaused,
  reconnect: messages.statusReconnect,
  provisioning: messages.statusProvisioning,
};

const TONE: Record<OutreachMailboxHealth, string | undefined> = {
  ok: styles.pillOk,
  warming: styles.pillWarm,
  paused: styles.pillBad,
  reconnect: styles.pillAmber,
  provisioning: styles.pillAmber,
};

/** The status of a mailbox as a pill with a dot (design outreach-v2 q1, q3). */
const MailboxStatusPillComponent: React.FC<{ health: string }> = ({ health }) => {
  const intl = useIntl();
  const key: OutreachMailboxHealth = health in LABEL ? (health as OutreachMailboxHealth) : 'paused';
  return (
    <span className={clsx(styles.pill, TONE[key])} data-testid={`mailbox-health-${key}`}>
      <i />
      {intl.formatMessage(LABEL[key])}
    </span>
  );
};

export const MailboxStatusPill = TypedMemo(MailboxStatusPillComponent);
